<template>
  <div>
    <div style="width: 100%; height: 217px" :id="id"></div>
    <a-modal title="详细" width="70%" :confirm-loading="confirmLoading" @cancel="handleCancel" :visible="visible"
      :footer="null">
      <a-table rowKey="id" :columns="columns" :data-source="list" :scroll="{ x: 1700 }" :pagination="{ pageSize: 10 }"
        size="small" bordered>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getUUID } from '../../../../../utils/util'
import chartResize from '@/mixin/chart-resize'
let unwatch, myChart
export default {
  mixins: [chartResize],
  name: 'NestedRing',
  components: {},
  data () {
    return {
      id: getUUID(),
      visible: false,
      confirmLoading: false,
      list: [],
      columns: [
        {
          title: '安装地址',
          dataIndex: 'address',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '水表厂商',
          dataIndex: 'factory',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '水表名称',
          dataIndex: 'flowMeterName',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '水表编码',
          dataIndex: 'flowMeterNo',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '计量电池',
          dataIndex: 'meteringBattery',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '通讯电池',
          dataIndex: 'communicationBattery',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '通讯电压',
          dataIndex: 'communicationVoltage',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        },
        {
          title: '计量电压',
          dataIndex: 'meterVoltage',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'layer' }
        }
      ]
    }
  },
  props: {
    data: {
      type: Object
    },
    total: {
      type: Number
    }
  },
  myChart: null,
  methods: {
    set (data) {
      var option
      option = {
        title: data.title,
        dataZoom: [
          {
            show: true,
            type: 'slider',
            bottom: '4%'
          }
        ],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var result = ''
            result +=
              '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FB7800;"></span>' +
              params[0].name +
              '<br>' +
              '个数：' +
              params[0].data

            return result
          }
        },
        grid: data.grid,
        color: data.color,
        // title: data.title ,
        calculable: true,

        xAxis: {
          type: 'category',
          data: data.xdata,
          axisLabel: {
            rotate: data.rotate == 0 ? 0 : 30,
            margin: 8,
            formatter: function (params) {
              var val = ''
              if (params.length > 3) {
                val = params.substr(0, 3) + '..'
                return val
              } else {
                return params
              }
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '个',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            data: data.seriseData,
            type: 'bar',
            barWidth: data.barwidth ? data.barwidth : 16 // 柱图宽度
          }
        ]
      }

      this.myChart.setOption(option)
      // 柱形图的单个点击效果
      this.myChart.getZr().on('click', (params) => {
        console.log('点击了')
        // 拿索引
        const pointInpixel = [params.offsetX, params.offsetY]
        const pointInGrid = this.myChart.convertFromPixel({ seriesIndex: 0 }, pointInpixel)
        const xIndex = pointInGrid[0]
        console.log(xIndex)

        this.visible = true
        this.list = this.data.meterList[xIndex]
        console.log(this.list)
        console.log(this.data.meterList[xIndex])
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    drawRingGraph (id) {
      const _this = this
      this.myChart = echarts.init(document.getElementById(id))

      unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            console.log(newvalue, 'newvalue')
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    }
  },
  mounted () {
    this.drawRingGraph(this.id)
  },
  created () { },
  beforeDestroy () {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  }
}
</script>
<style lang="less" scoped></style>
